/**
 * Re-export the canonical core enums + add shared-only enum vocabularies that
 * cross the HTTP / WebSocket boundary. Keep this file thin — actual game logic
 * lives in @stahlfront/core; here we only assert the wire-level taxonomy.
 */
export {
  FACTIONS,
  type Faction,
} from "@stahlfront/core";

export {
  BUILDING_FAMILIES,
  type BuildingFamily,
} from "@stahlfront/core";

export {
  STOCKPILE_RESOURCES,
  INDUSTRIAL_MATERIALS,
  INVENTORY_CATEGORIES,
  CRATE_TIERS,
  type StockpileResource,
  type IndustrialMaterial,
  type InventoryCategory,
  type CrateTier,
} from "@stahlfront/core";

export {
  CITY_TIERS,
  CITY_LOAD_STATES,
  type CityTier,
  type CityRole,
  type CityLoadState,
} from "@stahlfront/core";

export {
  UNIT_BRANCHES,
  type UnitBranch,
  type UnitClass,
  type UnitTier,
  type UnitStar,
} from "@stahlfront/core";

export {
  OFFICER_SKILL_SLOTS,
  type SkillSlot,
  type OfficerRarity,
} from "@stahlfront/core";

/** Alliance member rank ladder per spec §16.3. */
export type AllianceRank = "R0" | "R1" | "R2" | "R3" | "R4";
export const ALLIANCE_RANKS: readonly AllianceRank[] = ["R0", "R1", "R2", "R3", "R4"] as const;

/** Inbox tabs per spec §16.8.1. */
export type InboxTab =
  | "PERSONAL"
  | "BATTLE_REPORTS"
  | "REPORTS"
  | "ALLIANCE"
  | "SYSTEM"
  | "SENT"
  | "FAVORITES";
export const INBOX_TABS: readonly InboxTab[] = [
  "PERSONAL",
  "BATTLE_REPORTS",
  "REPORTS",
  "ALLIANCE",
  "SYSTEM",
  "SENT",
  "FAVORITES",
] as const;

/** Battle outcome surfaced in §17.9.1 report header. */
export type BattleOutcome = "VICTORY" | "DEFEAT" | "STALEMATE" | "WITHDRAWN";

/** Camera zoom layers per spec §2 — exposed here so server-driven UI hints can target a layer. */
export type ZoomLayer = "BASE" | "REGIONAL" | "WORLD" | "TACTICAL";
export const ZOOM_LAYERS: readonly ZoomLayer[] = ["BASE", "REGIONAL", "WORLD", "TACTICAL"] as const;
